export default __webpack_public_path__ + "static/media/product-owner3.33c34e40.png";